import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ChatService } from 'src/app/services/chat-service.service';
import { ProjectRole } from 'src/app/classes/enum/role';
import { DarkModeService } from 'src/app/services/dark-mode.service';
import { Router } from '@angular/router';
import { AuthorizationService } from 'src/app/services/authorization.service';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  @Input() header = false
  isResearchType : boolean
  openSetting: boolean = false;
  userName: string = '';
  firstLetterName: string = '';
  projectRole: string | null;
  ProjectRole= ProjectRole
  numberOfResearch: number = 10;
  isDarkModeCheck: boolean | null = this.darkModeService.isDarkMode && this.router.url != '/';
  darkModeToggle: boolean = false;
  @ViewChild('toggleButtonSetting') toggleButtonSetting!: ElementRef;
  hebrew : boolean = false




  constructor(
    private chatService: ChatService,
    private darkModeService: DarkModeService,
    private router: Router,
    private authorizationService: AuthorizationService,
    
  ) { 
    this.projectRole = localStorage.getItem('rolesDisplay');
  }

  ngOnInit(): void {
    this.isDarkModeCheck = this.darkModeService.isDarkMode && this.router.url != '/';
    this.isResearchType = this.chatService.isResearchType(this.projectRole as ProjectRole)
    this.userName = this.authorizationService.getUserName();
    this.firstLetterName = this.userName ? this.userName[0] : "";
    this.hebrew = this.chatService.isHebrewChat()
  }

    setOpenSetting() {
    this.openSetting = !this.openSetting;
  }

  saveToLocalStorage(){
    if(this.numberOfResearch > 50)
       this.numberOfResearch = 50
      else if(this.numberOfResearch == null || this.numberOfResearch ==0){
        this.numberOfResearch = 10
      }
    localStorage.setItem('numberOfResearch', this.numberOfResearch.toString());
  }

    toggleDarkMode() {
    this.darkModeService.toggleDarkMode();
    this.isDarkModeCheck = this.darkModeService.isDarkMode;
  }

    logout(): void {
    this.authorizationService.logout();
    this.router.navigate(['/']);
  }

}
